import React from 'react'
import { useNavigate } from 'react-router-dom'

import Container from '../Container/Container'

const InvalidSignupError: React.FC = (): React.ReactElement => {
  const navigate = useNavigate()

  const handleLoginClick: React.MouseEventHandler<HTMLAnchorElement> = (e) => {
    e.preventDefault()
    navigate('/')
  }

  return (
    <Container>
      <h1>Invalid sign up link</h1>
      <p>
        An email was sent that included a sign up link. That link must be used
        in order to create your account.
      </p>
      <p>
        If you already have an account,{' '}
        <a onClick={handleLoginClick}>click here</a> to log in.
      </p>
    </Container>
  )
}

export default InvalidSignupError
